import { render, staticRenderFns } from "./ContentProfileAnalyticsTiktok.vue?vue&type=template&id=b70b1554&scoped=true&"
import script from "./ContentProfileAnalyticsTiktok.vue?vue&type=script&lang=js&"
export * from "./ContentProfileAnalyticsTiktok.vue?vue&type=script&lang=js&"
import style0 from "./ContentProfileAnalyticsTiktok.vue?vue&type=style&index=0&id=b70b1554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70b1554",
  null
  
)

export default component.exports